import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "16_html-status-not-solved.svg",
  "use": "16_html-status-not-solved.svg-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"16_html-status-not-solved.svg\"><rect width=\"16\" height=\"16\" transform=\"translate(0 16) rotate(-90)\" style=\"fill:none\" /><circle cx=\"8\" cy=\"8\" r=\"5\" style=\"fill:#ff9198;stroke:#d42314;stroke-miterlimit:10\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol